import * as atypes from "src/constants/actionTypes";

export const getLlmModels = () => ({
  type: atypes.GET_LLM_MODELS_REQUEST,
  payload: {},
});
